/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Type of an avalanche
 * @export
 * @enum {string}
 */

export const AvalancheType = {
    Slab: 'SLAB',
    LooseSnow: 'LOOSE_SNOW',
    FullDepth: 'FULL_DEPTH',
    Unknown: 'UNKNOWN'
} as const;

export type AvalancheType = typeof AvalancheType[keyof typeof AvalancheType];



